import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type CatchUpGuidesRoute from 'teacher-ui-client/subscription-type/catch-up-guides/route'
import type CatchUpGuidesController from 'teacher-ui-client/subscription-type/catch-up-guides/controller'
import { RadioButtonGroup } from 'teacher-ui-client/components/base/radio-button-group'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { CatchUpGuideTile } from 'teacher-ui-client/components/catch-up-guide-tile'

interface Signature {
  Args: {
    model: ModelFor<CatchUpGuidesRoute>
    controller: CatchUpGuidesController
  }
}
export const CatchUpGuidesPage: TOC<Signature> = <template>
  <div class="w-full">
    <PageHeader>
      <:title>
        <h1>
          {{@controller.title}}
        </h1>
      </:title>
    </PageHeader>

    <RadioButtonGroup
      data-test-grade-position-filter
      class="mt-6 mb-4 flex justify-center"
      @name="grade-select"
      @buttons={{@controller.gradePositionFilterButtons}}
      @value={{@controller.currentlyFilteredGradePosition}}
      @onSelect={{@controller.filterByGradePosition}}
    />

    <div class="mx-6 flex w-full flex-wrap">
      {{#each @controller.currentlyVisibleGuides as |guide|}}
        <CatchUpGuideTile
          data-test-catch-up-guide-tile
          @title={{guide.title}}
          @description={{guide.description}}
          @coverUrl={{guide.coverUrl}}
          @fileUrl={{guide.fileUrl}}
          @gradePosition={{guide.gradePosition}}
        />
      {{/each}}
    </div>
  </div>
</template>

export default RouteTemplate(CatchUpGuidesPage)
